// extracted by mini-css-extract-plugin
export var pollAnswerAfterSlot = "PollAnswer-module--pollAnswerAfterSlot--ca5d7";
export var pollAnswerBeforeSlot = "PollAnswer-module--pollAnswerBeforeSlot--ad0b0";
export var pollAnswerContainer = "PollAnswer-module--pollAnswerContainer--f3f43";